import axios from '@/utils/axios'
import { Chinese } from '@/locales/zh';
import store from '@/store';

export const trackLog  =  (params: object, {currentLanguage = '中文'}) => {
  let countryCode = 'be_null'
  try {
    countryCode = store.getState()?.common?.country || 'be_null';
  } catch(e) {}
  return axios.post('/api/gateway/login/intl/track/h5/new', params, {
    headers: {
      source_type: 'H5',
      country_code: countryCode,
      country: Chinese[countryCode] || 'be_null',
      timestamp: Date.now(),
    }
  });
}

